var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('checkbox',{key:'form-' + _vm.form.slug,attrs:{"name":'forms[' + _vm.form.id + ']',"value":_vm.form.id,"selected":_vm.selectedSourceForms[_vm.form.slug]},on:{"change":function($event){return _vm.$emit('change')}}},[_c('template',{slot:"label"},[_vm._v("\n      "+_vm._s(_vm.form.name)+"\n    ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }